module.exports = "<div class=\"accounts-licenses-content-container\" >\n    <ng-include src=\"'app/accounts/licenses/licensesTable/licensesTable.html'\"></ng-include>    \n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/licenses/licenses.html
// module id = 485
// module chunks = 1